import {ControlButton} from "@ui/buttons/ControlButton";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const ViewTitle = ({value, handleClickEdit}) => {
  const {demo} = useSelector((state) => state.common.candidate);
  const {t} = useTranslation();

  return (
    <div className={styles.viewTitle}>
      <h2 dangerouslySetInnerHTML={{__html: value}} />

      {!demo && handleClickEdit && (
        <ControlButton
          color={"var(--blue)"}
          txt={t("button.edit")}
          onClick={handleClickEdit}
        />
      )}
    </div>
  );
};
